import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thumb'
})
export class ThumbPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';
    const qIdx = value.indexOf('?');
    const hIdx = value.indexOf('#');
    let cutIndex = value.length;
    if (qIdx !== -1 && hIdx !== -1) cutIndex = Math.min(qIdx, hIdx);
    else if (qIdx !== -1) cutIndex = qIdx;
    else if (hIdx !== -1) cutIndex = hIdx;

    const mainPart = value.slice(0, cutIndex);
    const tail = value.slice(cutIndex);

    const lastDot = mainPart.lastIndexOf('.');
    const thumbMain = lastDot === -1
      ? mainPart + '_thumb.jpg'
      : mainPart.slice(0, lastDot) + '_thumb.jpg';

    return thumbMain + tail;
  }

}
